import * as React from 'react';
import { useMemo } from 'react';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import { Period, PlanInformation } from 'types/api/backorder';
import PlanTable from 'components/backorder/table/planTable/PlanTable';
import {
  getCurrentPlanTableColumns,
  currentPlanTableHeader,
} from 'components/backorder/table/planTable/planTableData';

interface Props {
  currentPlan: PlanInformation;
  measurementPeriod: Period;
}

const CurrentPlanTable = ({ currentPlan, measurementPeriod }: Props): React.ReactElement => {
  const columns = useMemo(
    () => getCurrentPlanTableColumns(measurementPeriod.endDate),
    [measurementPeriod.endDate],
  );

  return (
    <DataTableLayout description={<span>Date in UTC</span>}>
      <PlanTable<PlanInformation>
        planInformation={[currentPlan]}
        header={currentPlanTableHeader}
        columns={columns}
      />
    </DataTableLayout>
  );
};

export default CurrentPlanTable;
